import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Separator } from 'telia-front-react';

import { SsoStore } from '../../../stores/SsoStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import NoticeWithButton from '../../common/NoticeWithButton';
import EmployeeUsagesStore from '../../../stores/EmployeeUsagesStore';

interface ILineUsagesEmployeeNoticeProps {
  children?: React.ReactNode;
  translateStore?: ITranslateStore;
  employeeUsagesStore?: EmployeeUsagesStore;
  ssoStore?: SsoStore;
}

@inject('translateStore', 'employeeUsagesStore', 'ssoStore')
@observer
export default class LineUsagesEmployeeNoticeBoundary extends React.Component<ILineUsagesEmployeeNoticeProps> {
  public render(): React.ReactNode {
    const translate = this.props.translateStore.translate;

    if (this.props.ssoStore.isDealer && !this.props.employeeUsagesStore.hasEmployeeCheckedUsages) {
      return (
        <React.Fragment>
          <Separator spacing="small" color="invisible" />
          <NoticeWithButton
            gaEvent="Link - usages for employee"
            noticeType="employee"
            noticeText={translate('shared.invoice-details-modal.employee-usages-check.notice')}
            buttonProps={{
              id: 'invoice-details-modal-invoice-line-usages-employee-button',
              iconRight: '#arrow-right',
              text: translate('shared.invoice-details-modal.employee-usages-check.button'),
              type: 'employee',
              onClick: () => this.props.employeeUsagesStore.changeHasCheckedUsagesTrueAndDontShowNotice()
            }}
          />
          <Separator spacing="small" color="invisible" />
        </React.Fragment>
      );
    }
    return this.props.children;
  }
}
